import _debounce from "lodash/debounce";
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { BOX_BUILDER_SELECT_PRODUCTS_DRAWER, SUPER_SPEED_BOX_TYPE_CHANGE_CONFIRMATION } from 'swag-client-common/constants';
import { isEditingBoxTypeBoxIdSelector, selectedOrExistedFullyCustomBoxInfoSelector, showSuperSpeedConfPopupSelector } from '../../../../../redux/box-builder/box-builder.selectors';
import { saveEditedBoxItselfInfo, saveFullyCustomBoxInfo, selectBackButton, typeFullyCustomBoxInfo } from '../../../../../redux/box-builder/box-builder.actions';
import { STEPS } from '../../../../../redux/box-builder/box-builder.constants';
import FullyCustomBoxSelection from './fully-custom-box-selection';
const mapStateToProps = createStructuredSelector({
  isBoxTypeEdit: isEditingBoxTypeBoxIdSelector,
  note: createSelector(selectedOrExistedFullyCustomBoxInfoSelector, fullyCustomBoxInfo => fullyCustomBoxInfo === null || fullyCustomBoxInfo === void 0 ? void 0 : fullyCustomBoxInfo.note),
  showSuperSpeedConfPopup: showSuperSpeedConfPopupSelector
});
const mapDispatchToProps = dispatch => {
  const debouncedDispatchTypeFullyCustomBoxInfo = _debounce(name => {
    dispatch(typeFullyCustomBoxInfo(name));
  }, 250);
  return {
    onBackHandler: () => {
      dispatch(selectBackButton(STEPS.FULLY_CUSTOM_BOX_SELECTION));
    },
    onNext: (note, isEditMode, showSuperSpeedConfPopup) => {
      dispatch(saveFullyCustomBoxInfo(note));
      if (isEditMode) {
        if (showSuperSpeedConfPopup) {
          dispatch(showPopup({
            popup: SUPER_SPEED_BOX_TYPE_CHANGE_CONFIRMATION
          }));
        } else {
          dispatch(saveEditedBoxItselfInfo());
        }
      } else {
        dispatch(showPopup({
          popup: BOX_BUILDER_SELECT_PRODUCTS_DRAWER
        }));
      }
    },
    onChange: note => {
      debouncedDispatchTypeFullyCustomBoxInfo(note);
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FullyCustomBoxSelection);